import { FastlyImage } from '@components/common/image'
import { CODINGAL_OFFERING } from '@lib/data/summer-coding-camp'

type CodingalOfferingProps = {
  title: JSX.Element
}

const CodingalOffering = ({ title }: CodingalOfferingProps) => {
  return (
    <div className="md:mb-10 text-grey px-3 py-12 lg:py-16 bg-blue-50 bg-opacity-25">
      <div className="container mx-auto items-center flex flex-col">
        <h2 className="mb-10 leading-tight font-600 max-w-3xl text-2xl lg:text-4xl text-center">
          {title}
        </h2>
        <div className="flex flex-wrap justify-center lg:flex-row font-600 text-lg lg:text-2xl leading-6 lg:leading-8 max-w-5xl">
          {CODINGAL_OFFERING.map((codingalOffering, index) => {
            return (
              <div className="p-2" style={{ width: '284px' }} key={index}>
                <div className="bg-white h-full rounded-md border-blue-100 border-solid hover:border-blue-200 border-2 shadow-2d-blue md:p-5 p-3">
                  <p>
                    <span className="mr-2">
                      <FastlyImage
                        src={`/images/home/codingal-offering/${codingalOffering.image}`}
                        width={codingalOffering.imageWidth}
                        height={codingalOffering.imageHeight}
                      />
                    </span>
                    {codingalOffering.content}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className="flex justify-center pt-16">
        <a
          className="btn btn-orange w-full md:w-auto py-3 text-lg text-center"
          href="#courses"
        >
          Claim your spot now
        </a>
      </div>
    </div>
  )
}

export default CodingalOffering
